import { Contract } from './contracts.types';

export const getContractFromRoleId = (contracts: Contract[], roleId: string) => {
  const contract = contracts.find(c => {
    return Boolean(c.roles?.find(r => r.id === roleId));
  });

  return contract;
};

export const getContractById = (id: string, contracts: Contract[]) => {
  const contract = contracts.find(c => c.id === id);

  if (!contract && id) throw new Error(`Missing contract with id ${id}`);

  return contract;
};
